{
  "version": 1,
  "asset_id": "a027592e-edf6-4f8e-8deb-822ec201bdbb",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/a027592e-edf6-4f8e-8deb-822ec201bdbb/avcilar-hizli-elektrikci-7-24-dukkan-1.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/a027592e-edf6-4f8e-8deb-822ec201bdbb/avcilar-hizli-elektrikci-7-24-dukkan-1.jpg",
  "original_filename": "avcilar-hizli-elektrikci-7-24-dukkan-1.jpg",
  "size": 558655,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T13:23:25Z"
}
